import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = still checking, false = unauthenticated, object = admin
    const [admin, setAdmin] = useState(null);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("dogaparquet_token");
        if (!token) {
            setAdmin(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setAdmin(data);
        } catch {
            localStorage.removeItem("dogaparquet_token");
            setAdmin(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("dogaparquet_token", data.access_token);
        await refresh();
        return data;
    };

    const logout = () => {
        localStorage.removeItem("dogaparquet_token");
        setAdmin(false);
    };

    return (
        <AuthContext.Provider value={{ admin, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
